export enum CandidateTableTypes {
	Approved = 'approved',
	Pending = 'pending',
	Denied = 'denied',
}